document.addEventListener('DOMContentLoaded', function() {
	if(document.querySelector('.module-tarifrechner[data-show-tabs="tab-1"]')) {
			// Für Tab 1
			const tab1 = document.querySelector('#tab-1');
			const tab2 = document.querySelector('#tab-2');
			
			if (tab1 && tab2) {
					tab1.classList.add('current');
					tab2.classList.add('disabled');
			}
	} else if(document.querySelector('.module-tarifrechner[data-show-tabs="tab-2"]')) {
			// Für Tab 2
			const tab1 = document.querySelector('#tab-1');
			const tab2 = document.querySelector('#tab-2');
			
			if (tab1 && tab2) {
					tab2.classList.add('current');
					tab1.classList.add('disabled');
			}
	}
});